function u(l) {
  throw new Error("Unexpected object: " + l);
}
var c = (i => (i[i.First = 0] = "First", i[i.Previous = 1] = "Previous", i[i.Next = 2] = "Next", i[i.Last = 3] = "Last", i[i.Specific = 4] = "Specific", i[i.Nothing = 5] = "Nothing", i))(c || {});
function f(l, n) {
  let t = n.resolveItems();
  if (t.length <= 0) return null;
  let r = n.resolveActiveIndex(),
    s = r != null ? r : -1;
  switch (l.focus) {
    case 0:
      {
        for (let e = 0; e < t.length; ++e) if (!n.resolveDisabled(t[e], e, t)) return e;
        return r;
      }
    case 1:
      {
        s === -1 && (s = t.length);
        for (let e = s - 1; e >= 0; --e) if (!n.resolveDisabled(t[e], e, t)) return e;
        return r;
      }
    case 2:
      {
        for (let e = s + 1; e < t.length; ++e) if (!n.resolveDisabled(t[e], e, t)) return e;
        return r;
      }
    case 3:
      {
        for (let e = t.length - 1; e >= 0; --e) if (!n.resolveDisabled(t[e], e, t)) return e;
        return r;
      }
    case 4:
      {
        for (let e = 0; e < t.length; ++e) if (n.resolveId(t[e], e, t) === l.id) return e;
        return r;
      }
    case 5:
      return null;
    default:
      u(l);
  }
}
export { c as Focus, f as calculateActiveIndex };